import { memo } from 'react';
import { IUniqkeyImageProp } from '../interfaces';

const UniqkeyShieldLogoImage = (props: IUniqkeyImageProp) => {
  const { height = 232, width = 265 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 182 162" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.25"
        d="M178 97C181.688 85.2675 183.08 72.659 181 60C175.698 27.708 151.292 -7.10187 117 1.99999C99.8567 6.548 88.73 26.318 78 40C67.5651 53.3079 55.1089 66.1706 39 69C25.7846 71.3383 10.9248 68.2423 2.99999 83C-5.94264 99.6429 7.86445 122.344 19 134C32.516 148.156 50.3644 156.928 69 160C92.8681 163.94 118.116 159.864 139 147C156.88 135.989 171.446 117.837 178 97Z"
        fill="#D8E6FC"
      />
      <path
        d="M62 15.1794H59.1794V18C59.1794 23.9663 57.0718 29.981 53.0159 33.9953C48.9301 38.0391 43.0074 40.1794 37 40.1794H34.1794V43V59.9909C34.098 72.6654 36.5514 85.3377 41.3925 97.0754L41.3964 97.0848L41.4003 97.0941C50.9926 119.886 68.7261 137.325 90.3143 142.736L91.0006 142.908L91.6868 142.736C113.238 137.325 131.007 119.888 140.6 97.0941L140.604 97.0848L140.608 97.0754C145.449 85.3378 147.902 72.6655 147.821 59.991V43V40.1794H145C142.098 40.1794 138.78 39.5015 136.07 38.3902C133.223 37.2232 130.948 35.9392 128.984 33.9953C127.265 32.2943 126.101 29.5022 124.837 26.4749C124.759 26.2878 124.681 26.0998 124.602 25.9111C123.439 23.1331 122.821 20.7668 122.821 18V15.1794H120H113H62Z"
        fill="white"
        stroke="#3366CC"
        strokeWidth="5.64114"
        strokeMiterlimit="10"
      />
      <path
        d="M138 96C128.779 118.165 111.261 134.854 91 140V18H112.592H120C120 21.2502 120.758 23.9972 122 27C123.242 30.0028 124.705 33.7018 127 36C129.295 38.2982 131.501 39.7562 134.5 41C137.499 42.2438 141.754 43 145 43V60C145.079 72.3004 142.643 84.6116 138 96Z"
        fill="#F0F3FB"
      />
      <path
        d="M96.1667 50.8276C94.6019 50.8276 93.3333 49.5374 93.3333 47.9458V38.8818C93.3333 37.2902 94.6019 36 96.1667 36C97.7315 36 99 37.2902 99 38.8818V47.9458C99 49.5374 97.7315 50.8276 96.1667 50.8276Z"
        fill="#3366CC"
      />
      <rect x="93.3333" y="46.3448" width="5.66667" height="28.2759" fill="#3366CC" />
      <rect x="93.3333" y="64.9655" width="5.66667" height="18.6207" fill="#3366CC" />
      <rect x="107.405" y="68.7621" width="5.59483" height="14.9288" fill="#3366CC" />
      <path
        d="M93.4088 63.5298C93.7086 64.4902 94.4679 65.2199 95.4137 65.4568C96.3595 65.6936 97.356 65.4035 98.045 64.6908L99.0036 63.7001V61.2813L100.175 62.4926L104.138 58.3961L112.176 50.0755C112.699 49.5339 112.995 48.7992 112.998 48.0321V38.9026C112.998 37.2995 111.746 36 110.201 36C108.656 36 107.403 37.2995 107.403 38.9026V46.8227L100.175 54.2977L99.0036 55.5091L96.2062 58.3961L94.1044 60.5827C93.789 60.9072 93.553 61.3053 93.4162 61.7437L93.4088 63.5298Z"
        fill="#3366CC"
      />
      <path
        d="M112.998 68.7621V83.6929L110.201 85.3104L107.403 83.6929V69.9677L100.175 62.4926L99.0036 61.2813L96.2062 58.3961L94.1044 56.2076L98.045 52.0956L99.0036 53.0864V55.509L100.175 54.2977L104.138 58.3961L112.176 66.7071C112.702 67.2516 112.998 67.991 112.998 68.7621Z"
        fill="#3366CC"
      />
      <path
        d="M86.8333 50.8276C85.2685 50.8276 84 49.5374 84 47.9458V38.8818C84 37.2902 85.2685 36 86.8333 36C88.3981 36 89.6667 37.2902 89.6667 38.8818V47.9458C89.6667 49.5374 88.3981 50.8276 86.8333 50.8276Z"
        fill="#3366CC"
      />
      <path
        d="M89.6667 65.0573V46.3448H84V53.2403V56.5468V64.4187V67.7252V74.6207H89.6667V67.4745V65.0573Z"
        fill="#3366CC"
      />
      <rect x="84" y="64.9655" width="5.66667" height="18.6207" fill="#3366CC" />
      <rect x="70" y="68.7621" width="5.59483" height="14.9288" fill="#3366CC" />
      <path
        d="M89.5912 61.7496C89.4547 61.311 89.2187 60.9128 88.9031 60.5885L86.7882 58.4019L83.9908 55.5149L82.8178 54.3035L75.5948 46.8227V38.9026C75.5948 37.2995 74.3424 36 72.7974 36C71.2524 36 70 37.2995 70 38.9026V48.0321C70.0011 48.8019 70.297 49.5397 70.8224 50.0832L78.8603 58.4039L82.8234 62.5003L83.9964 61.289V63.7059L84.9531 64.6947C86.0455 65.8278 87.8163 65.8278 88.9087 64.6947C89.2225 64.37 89.4566 63.9718 89.5912 63.5337V61.7496Z"
        fill="#3366CC"
      />
      <path
        d="M88.9031 56.2076L86.7882 58.3961L83.9908 61.2813L82.8178 62.4926L75.5948 69.9677V83.6929L72.7974 85.138L70 83.6929V68.7621C70.0002 67.991 70.2961 67.2516 70.8224 66.7071L78.8603 58.3961L82.8234 54.2977L83.9964 55.509V53.0844L84.9531 52.0956L88.9031 56.2076Z"
        fill="#3366CC"
      />
      <path
        d="M91.4935 106C79.6276 105.983 70.0134 96.0048 70 83.6929H75.5948C75.5948 92.8067 82.7154 100.195 91.4991 100.195C100.283 100.195 107.403 92.8067 107.403 83.6929H112.998C112.985 96.0093 103.364 105.989 91.4935 106Z"
        fill="#3366CC"
      />
      <path
        d="M96.1667 89.7931C94.6019 89.7931 93.3333 88.5161 93.3333 86.9409V83.6798C93.3333 82.1046 94.6019 80.8276 96.1667 80.8276C97.7315 80.8276 99 82.1046 99 83.6798V86.9409C99 87.6973 98.7015 88.4228 98.1701 88.9577C97.6388 89.4926 96.9181 89.7931 96.1667 89.7931Z"
        fill="#3366CC"
      />
      <path
        d="M86.8333 89.7931C85.2685 89.7931 84 88.5161 84 86.9409V83.6798C84 82.1046 85.2685 80.8276 86.8333 80.8276C88.3981 80.8276 89.6667 82.1046 89.6667 83.6798V86.9409C89.6667 87.6973 89.3682 88.4228 88.8368 88.9577C88.3054 89.4926 87.5848 89.7931 86.8333 89.7931Z"
        fill="#3366CC"
      />
    </svg>

  );
};

export default memo(UniqkeyShieldLogoImage);
